import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=15b2aa93&scoped=true"
import script from "./tableView.vue?vue&type=script&lang=js"
export * from "./tableView.vue?vue&type=script&lang=js"
import style0 from "./tableView.vue?vue&type=style&index=0&id=15b2aa93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2aa93",
  null
  
)

export default component.exports